export default __webpack_public_path__ + "static/media/logo-sos-3d.a0f2482a.webp";